import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import ModalHeader from "react-bootstrap/ModalHeader";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";

import LiveSendTipCard from "../Live/components/LiveSendTipCard";
import { fetchWalletDetailsStart } from "../../../store/actions/WalletAction";
import { sendStreamingTipWalletStart } from "../../../store/actions/SendTipAction";
import { SocketContext as StreamingSocketContext } from "../../../helpers/contexts/streaming";

import "./styles/SharedComponent.css";
import CloseIcon from "../../../images/icons/close_icon.svg?react";

export default function SendTipStreamModal({ isOpen, toggleModal }) {
  const methods = useForm();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.modals.general);
  const { sendTipSentNotification } = useContext(StreamingSocketContext);

  useEffect(() => {
    dispatch(fetchWalletDetailsStart());
  }, []);

  const onSuccess = (response) => {
    toggleModal();
    sendTipSentNotification({
      channelId: data.channel_id,
      paymentId: response.data.payment_id
    });
  }

  const handleSendTip = (payload) => {
    dispatch(sendStreamingTipWalletStart({
      ...payload,
      user_id: data.user.id,
      channel_id: data.channel_id,
      onSuccess: onSuccess
    }));
  };

  return (
    <>
      <Modal
        show={isOpen}
        onHide={toggleModal}
        contentClassName="end-live-modal"
        centered
        className={`unlock verify ${
          localStorage.getItem("isDark") === "true" ? "dark" : "light"
        }`}
      >
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSendTip)} translate="no">
            <ModalHeader className="end-modal d-flex w-100 align-items-center">
              <h1 className="title">Send Tip</h1>
              <CloseIcon
                className="close-icon"
                role={"button"}
                aria-label="close"
                onClick={toggleModal}
              />
            </ModalHeader>
            <ModalBody className="end-modal-body stream-tip">
              <LiveSendTipCard data={data}/>
            </ModalBody>
            <ModalFooter className="mt-1 mx-2 mb-2">
              <button onClick={toggleModal} className="action-button-default">
                Cancel
              </button>
              <button className="action-button" type="submit">
                Confirm
              </button>
            </ModalFooter>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
}
